import { useParams } from 'react-router-dom';
import { routeKeysOf } from '@platform/navigation/routeKeys';
import { useAppSelector } from '@platform/state/hooks';
import { selectCurrentWorkspaceId } from '@platform/state/selectors';
import type { IWorkspaceParams } from './IWorkspaceParams';

/** Поточний робочий простір (стан сесії вкладки) і ключі маршруту, відновлені з сегментів адреси (routeKeysOf), з порожніми типовими значеннями. */
export function useWorkspaceParams(): IWorkspaceParams {
  const ws = useAppSelector(selectCurrentWorkspaceId) ?? '';
  return { ws, ...routeKeysOf(useParams()) };
}
